<template>
  <div id="index2">
    <div v-if="fixedMenu" class="fMenu" style="padding-top:5px">
      <div class="container" v-if="show">
        <div style="position: fixed;top:45px;height:0" @mouseleave="show=false">
          <div class="cate-menu1">
            <div v-for="(item,index) of cate" :key="index" @mousemove="hoverId=index">
              <router-link class="item" :to="'/results?topClass='+item.cate_name">
                <span
                  style="font-weight: 800;color:#333"
                >{{item.cate_name.slice(0,item.cate_name.indexOf('/'))}}</span>
                {{item.cate_name.slice(item.cate_name.indexOf('/'))}}
              </router-link>
            </div>
          </div>
          <div class="cate-menu2" v-if="hoverId!=null">
            <div v-for="n in 11" :key="n">
              <div v-if="hoverId==n-1&&show">
                <el-row>
                  <el-col :span="19">
                    <div v-if="cate[0]">
                      <div
                        v-for="(item2,index2) of cate[n-1].data"
                        :key="index2"
                        style="margin-bottom:8px;"
                      >
                        <router-link
                          :to="'/results?SecondClass='+item2.id"
                          style="font-weight:bold"
                        >{{item2.cate_name}}</router-link>
                        <i class="fas fa-angle-right" style="margin:0 8px;"></i>
                        <span v-for="(item3,index3) of item2.data" :key="index3">
                          <router-link
                            :to="'/results?ThirdClass='+item3.id"
                            style="margin-bottom:5px;display:inline-block"
                          >{{item3.cate_name}}</router-link>
                          <el-divider direction="vertical"></el-divider>
                        </span>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="5">
                    <div
                      style="background-color:rgb(221,221,221);padding: 10px 0"
                      v-if="rightAd[0]"
                    >
                      <el-row style="margin-bottom:10px;">
                        <el-col :span="12" v-for="n2 in 8" :key="n2">
                          <div
                            v-if="rightAd[n-1]&&rightAd[n-1]['brand'+(n2-1)]"
                            style="padding:1px;"
                          >
                            <router-link :to="'viewBrands?id=' + rightAd[n-1]['brand'+(n2-1)].id">
                              <img
                                :src="serve + '/'+ rightAd[n-1]['brand'+(n2-1)].logo_thumb"
                                style="width:100%;height:52px;"
                              />
                            </router-link>
                          </div>
                        </el-col>
                      </el-row>
                      <div v-if="rightAd[n-1]['image1']">
                        <router-link :to="rightAd[n-1]['link1']">
                          <img
                            :src="serve + '/'+rightAd[n-1]['image1']"
                            style="width:90%;margin: 3px auto;height:109px"
                          />
                        </router-link>
                      </div>
                      <div v-if="rightAd[n-1]['image2']">
                        {{rightAd[n-1]['image2']}}
                        <img
                          :src="serve + '/'+rightAd[n-1]['image2']"
                          style="width:90%;margin: 0 auto;height:109px"
                        />
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <el-row>
          <el-col :span="5">
            <div
              style="cursor: pointer;background-color: #e2211c;color: #fff;width: 200px;line-height: 40px;text-align: center;"
              @mousemove="show = true"
            >全部分类</div>
          </el-col>
          <el-col :span="16">
            <div style="line-height:40px;">
              <el-autocomplete
                size="mini"
                v-model="keywords2"
                :fetch-suggestions="autoComplete"
                placeholder="请输入商品名称或者货号"
                @select="handleSelect"
                style="width:500px"
                @keyup.enter.native="search()"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                <el-button slot="append" @click="search">
                  <div style="height:100%;width:100%">搜索</div>
                </el-button>
              </el-autocomplete>
            </div>
          </el-col>
          <el-col :span="3">
            <div style="line-height:40px;" v-if="isLogin==true">
              <el-popover @show="loadCart" placement="top" width="310" trigger="hover">
                <div class="car_shopping">
                  <div
                    v-if="count>0"
                    class="cartDialogue"
                    :class="carts.length > 5 ? 'cartDialogue1' :'' "
                  >
                    <div class="cartDialogue_top">最近加入的商品</div>
                    <div class="car_list" v-for="(item,index) of carts" :key="index">
                      <div class="img">
                        <img
                          style="width:50px;height:50px"
                          :src="serve + '/'+item.cover"
                          class="cover"
                        />
                      </div>

                      <div class="title">
                        <div
                          class="title_div1 title_div5"
                        >{{item.title.length>8? item.title.substr(0,8) + '...' : item.title}}</div>
                        <div>
                          <span class="title_div2">{{item.item_no}}</span>
                          <span class="title_div3">x {{item.number}}</span>
                        </div>
                      </div>
                      <div class="money title">
                        <div class="title_div1">&yen;{{item.selling_price}}</div>
                      </div>
                    </div>
                  </div>
                  <div v-if="count>0" class="go_shopping">
                    <div>
                      共
                      <span>{{count}}</span>
                      件商品
                    </div>
                    <div>
                      <router-link to="/user/cart">
                        <el-button type="primary" size="mini" round>去购物车结算</el-button>
                      </router-link>
                    </div>
                  </div>
                  <div
                    v-else-if="count==0"
                    class="lv3Text"
                    style="padding:10px;text-align:center"
                  >购物车内没有商品</div>
                </div>
                <el-button slot="reference" size="mini" round style="width:100px">
                  <i class="fas fa-shopping-cart fa-lg" style="margin-right:5px"></i>购物车
                </el-button>
              </el-popover>

              <!-- 、 -->
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="container lv2Text">
      <div>
        <el-row>
          <el-col :span="12" :offset="4">
            <div style="padding-left:10px;" class="car1">
              <el-carousel trigger="click" height="330px;" :interval="5000">
                <el-carousel-item v-for="(item,index) in banner" :key="index">
                  <router-link :to="banner_link[index]">
                    <img :src="serve + '/'+item" style="height:330px;" />
                  </router-link>
                </el-carousel-item>
              </el-carousel>
            </div>
          </el-col>
          <el-col :span="4">
            <div style="padding-left:10px;width: 190px;height:327px">
              <div v-if="images2.image">
                <router-link :to="images2.link.split(';')[0]">
                  <el-image
                    style="width: 190px; height: 163.5px"
                    :src="serve + '/'+images2.image.split(';')[0]"
                    fit="cover"
                  ></el-image>
                </router-link>
                <router-link :to="images2.link.split(';')[1]">
                  <el-image
                    style="width: 190px; height: 163.5px"
                    :src="serve + '/'+images2.image.split(';')[1]"
                    fit="cover"
                  ></el-image>
                </router-link>
              </div>
            </div>
          </el-col>
          <el-col :span="4">
            <div style="padding-left:10px;">
              <div class="box3" style="padding-top:20px">
                <div align="center" class="lv4Text" style="margin-bottom:10px">
                  <img
                    v-if="isLogin == true"
                    style="width:68px;height:68px;border-radius:50%;"
                    :src="isLogin_img"
                    alt
                  />
                  <div v-if="isLogin == false">
                    <i class="iconfont icon-yonghutouxiang" style="font-size:54px"></i>
                  </div>
                </div>
                <div
                  v-if="isLogin == true"
                  align="center"
                  style="margin-bottom:20px"
                  class="lv2Text"
                >嗨,{{isLogin_monile}}</div>
                <div
                  v-if="isLogin == false"
                  align="center"
                  style="margin-bottom:20px"
                  class="lv2Text"
                >欢迎来到宝枫林！</div>
                <div class="bt3">
                  <router-link v-if="isLogin == true" to="/group">
                    <el-button plain size="mini" style="padding: 7px 10px;">团购中心</el-button>
                  </router-link>
                  <router-link to="/login" v-if="isLogin == false">
                    <el-button plain size="mini" style="padding: 7px 10px;">立即登录</el-button>
                  </router-link>

                  <router-link v-if="isLogin == true" to="/limit">
                    <el-button plain size="mini" style="padding: 7px 10px;">限时折扣</el-button>
                  </router-link>
                  <router-link v-if="isLogin == false" to="/register">
                    <el-button plain size="mini" style="padding: 7px 10px;">快速注册</el-button>
                  </router-link>
                </div>
                <div class="bt4">
                  <router-link to="/idleHome">
                    <el-link type="primary" :underline="false">闲置 ></el-link>
                  </router-link>
                  <router-link to="/user/couponCenter">
                    <el-link type="primary" :underline="false">领券 ></el-link>
                  </router-link>
                </div>
                <div style="padding-top:10px">
                  <span class="lv2Text" style="font-weight:bold">宝枫林资讯</span>
                  <router-link to="/newsCenter">
                    <span class="lv4Text bioflin_advisory" style="float:right;font-size:12px;">
                      更多
                      <i class="fas fa-chevron-right" style="margin-left:2px"></i>
                    </span>
                  </router-link>
                </div>
                <div>
                  <el-carousel
                    height="75px"
                    direction="vertical"
                    :autoplay="true"
                    indicator-position="none"
                    :interval="5000"
                  >
                    <el-carousel-item v-for="(item,index) of newsList" :key="index">
                      <div style="line-height:1.5em;padding: 10px 0;">
                        <span class="lv0Text">[热点]</span>
                        <router-link :to="'/viewHotNews/' + item.id">
                          <span>{{item.title}}</span>
                        </router-link>
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div style="margin-top:30px;">
        <el-row>
          <el-col :span="4">
            <router-link to="/limit" class="clear rush" align="center">
              <div class="clear-item rush-item2" :class="second_bg" align="center">
                <div
                  style="font-size:26px;margin-top:49px;font-weight:bold;color:rgba(255,255,255,1);font-family:Microsoft YaHei;"
                >宝枫林秒杀</div>
                <div style="margin:25px 0 20px 0">
                  <i class="iconfont icon-shandian-shi" style="font-size:45px"></i>
                </div>
                <div
                  style="font-size:18px;font-family:Microsoft YaHei;font-weight:bold;color:rgba(255,255,255,1);"
                >
                  <span style="margin-right:7px">{{second_title}}</span>
                  <span
                    style="font-size:14px;font-family:Microsoft YaHei;font-weight:400; color:rgba(255,255,255,1);margin-left:7px"
                  >倒计时</span>
                </div>
                <div style="margin-top:19px">
                  <div class="x1">{{_.padStart(hours, 2, '0')}}</div>
                  <strong>:</strong>
                  <div class="x1">{{_.padStart(minutes, 2, '0')}}</div>
                  <strong>:</strong>
                  <div class="x1">{{_.padStart(seconds, 2, '0')}}</div>
                </div>
              </div>
            </router-link>
          </el-col>
          <el-col :span="20">
            <div
              style="overflow:hidden;height:270px"
              @mouseover="showRushC=true"
              @mouseleave="showRushC=false"
            >
              <div class="clear" style="width:1600px;">
                <div
                  class="rushItem clear-item"
                  v-for="(item,index) of rushProduct"
                  :key="index"
                  ref="rushItem"
                >
                  <router-link :to="'/product2/'+item.r_id">
                    <div style="height:20px"></div>
                    <div class="sechill_hover">
                      <img class="sechill_hover_img" :src="serve + '/'+item.images" alt />
                    </div>
                  </router-link>
                  <router-link :to="'/product2/'+item.r_id">
                    <div
                      style="text-align:center;overflow:hidden;margin-top:15px;text-overflow: ellipsis;white-space: nowrap"
                    >{{item.title}}</div>
                  </router-link>

                  <div class="rush_price_g">
                    <div class="rush_price_g1">&yen;{{item.rush_price}}</div>
                    <div class="rush_price_g1_bg"></div>
                    <div class="rush_price_g2">{{item.selling_price}}</div>
                  </div>
                </div>
              </div>
              <div v-if="showRushC" class="showRushC left">
                <span @click="leftBtn">
                  <i class="fas fa-chevron-left fa-2x"></i>
                </span>
              </div>
              <div v-if="showRushC" class="showRushC right">
                <span @click="rightBtn">
                  <i class="fas fa-chevron-right fa-2x"></i>
                </span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div style="margin-top:30px">
        <el-row :gutter="20">
          <el-col :span="6" v-for="(item,index) of ads" :key="index">
            <router-link target="_blank" style="cursor: pointer" :to="item.link">
              <img :src="serve +item.cover" style="width:100%" />
            </router-link>
          </el-col>
        </el-row>
      </div>

      <div style="margin-top:30px">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="box2">
              <div class="t3" style="margin-bottom:20px">
                <router-link target="_blank" to="requiredList">
                  <span class="new_biqiang">必抢清单</span>
                </router-link>
                <router-link target="_blank" to="requiredList">
                  <span
                    style="float:right;font-size:14px;font-weight:normal"
                    class="new_biqiang_span"
                  >
                    更多
                    <i class="iconfont icon-youjiantou" style="font-size:14px"></i>
                  </span>
                </router-link>
              </div>
              <div class="car2">
                <el-carousel trigger="click" height="430px">
                  <el-carousel-item v-for="(item,index) of required" :key="index">
                    <div style="margin-bottom:5px">
                      <router-link target="_blank" :to="item.link">
                        <img :src="serve + '/'+item.banner" style="width:100%" />
                      </router-link>
                    </div>
                    <div v-if="item.product">
                      <el-row :gutter="10">
                        <el-col :span="8">
                          <div>
                            <router-link target="_blank" :to="'/product/'+item.product[0].id">
                              <img
                                :src="serve + '/'+item.product[0].images"
                                style="width:110px; height:110px"
                              />
                            </router-link>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div>
                            <router-link target="_blank" :to="'/product/'+item.product[1].id">
                              <img
                                :src="serve +'/'+item.product[1].images"
                                style="width:110px; height:110px"
                              />
                            </router-link>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div>
                            <router-link target="_blank" :to="'/product/'+item.product[2].id">
                              <img
                                :src="serve +'/'+item.product[2].images"
                                style="width:110px; height:110px"
                              />
                            </router-link>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                    <div
                      class="lv2Text"
                      style="font-size:18px;margin:20px 0;text-align:center"
                    >{{item.content[0].title}}</div>
                    <div
                      class="lv3Text"
                      style="line-height:1.5em;height:84px;overflow:hidden"
                    >{{item.content[0].content}}</div>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="box2">
              <div class="t3" style="margin-bottom:20px">
                <router-link target="_blank" to="discoverList">
                  <span class="new_biqiang1">发现好货</span>
                </router-link>
                <router-link target="_blank" to="discoverList">
                  <span
                    style="float:right;font-size:14px;font-weight:normal"
                    class="new_biqiang_span"
                  >
                    更多
                    <i class="iconfont icon-youjiantou" style="font-size:14px"></i>
                  </span>
                </router-link>
              </div>
              <div>
                <div v-if="good!=null">
                  <el-row>
                    <el-col :span="12">
                      <div>
                        <router-link
                          v-if="good[0].id!=null"
                          target="_blank"
                          class="lookGood_a"
                          :to="'/product/'+good[0].id"
                        >
                          <el-image
                          v-if="good[0].images!=null"
                            style="width: 110px;height:110px;margin:30px 0 10px 32px;"
                            :src="serve +'/'+good[0].images"
                            fit="cover"
                          ></el-image>
                        </router-link>

                        <div class="lookGood">
                          <router-link
                          v-if="good[0].title!=null"
                            target="_blank"
                            class="lookGood_a"
                            :to="'/product/'+good[0].id"
                          >{{good[0].title.length>12? good[0].title.substr(0,12)+"..." : good[0].title}}</router-link>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div>
                        <router-link
                        v-if="good[1].id!=null"
                          target="_blank"
                          class="lookGood_a"
                          :to="'/product/'+good[1].id"
                        >
                          <el-image
                          v-if="good[1].id!=null"
                            style="width: 110px;height:110px;margin:30px 0 10px 32px;"
                            :src="serve +'/'+good[1].images"
                            fit="cover"
                          ></el-image>
                        </router-link>

                        <div class="lookGood">
                          <router-link
                          v-if="good[1].id!=null"
                            target="_blank"
                            class="lookGood_a"
                            :to="'/product/'+good[1].id"
                          >{{good[1].title.length>12? good[1].title.substr(0,12)+"..." : good[1].title}}</router-link>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
                <div v-if="good!=null">
                  <el-row>
                    <el-col :span="12">
                      <div>
                        <router-link
                          target="_blank"
                          :to="'/product/'+good[2].id"
                          class="lookGood_a"
                        >
                          <el-image
                            style="width: 110px;height:110px;margin:50px 0 10px 32px;"
                            :src="serve +'/'+good[2].images"
                            fit="cover"
                          ></el-image>
                        </router-link>

                        <div class="lookGood">
                          <router-link
                            target="_blank"
                            :to="'/product/'+good[2].id"
                            class="lookGood_a"
                          >{{good[2].title.length>12? good[2].title.substr(0,12)+"..." : good[2].title}}</router-link>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div>
                        <router-link
                          target="_blank"
                          :to="'/product/'+good[3].id"
                          class="lookGood_a"
                        >
                          <el-image
                            style="width: 110px;height:110px;margin:50px 0 10px 32px;"
                            :src="serve +'/'+good[3].images"
                            fit="cover"
                          ></el-image>
                        </router-link>

                        <div class="lookGood">
                          <router-link
                            target="_blank"
                            :to="'/product/'+good[3].id"
                            class="lookGood_a"
                          >{{good[3].title.length>12? good[3].title.substr(0,12) + '...' : good[3].title}}</router-link>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="box2">
              <div class="t2">
                <router-link class="new_pai" tag="span" to="/top">排行榜</router-link>

                <router-link target="_blank" to="/top" style="float:right" class="new_pai_span">
                  更多
                  <i class="iconfont icon-youjiantou" style="font-size:14px"></i>
                </router-link>
              </div>
              <div
                style="overflow:hidden;margin:15px 0;border-bottom:1px solid #ddd;padding:20px 0 10px 0;"
              >
                <div class="clear" style="width:2000px">
                  <div ref="rankItem" class="rankItemDiv">
                    <div
                      class="clear-item rankItem"
                      @click="currentRank=0"
                      :class="currentRank==0?'active':''"
                    >耗材</div>
                    <div
                      class="clear-item rankItem"
                      @click="currentRank=1"
                      :class="currentRank==1?'active':''"
                    >实验办公</div>
                    <div
                      class="clear-item rankItem"
                      @click="currentRank=2"
                      :class="currentRank==2?'active':''"
                    >试剂</div>
                    <div
                      class="clear-item rankItem"
                      @click="currentRank=3"
                      :class="currentRank==3?'active':''"
                    >抗体</div>
                    <div
                      class="clear-item rankItem"
                      @click="currentRank=4"
                      :class="currentRank==4?'active':''"
                    >仪器设备</div>
                    <div
                      class="clear-item rankItem"
                      @click="currentRank=5"
                      :class="currentRank==5?'active':''"
                    >模式生物</div>
                    <div
                      class="clear-item rankItem"
                      @click="currentRank=6"
                      :class="currentRank==6?'active':''"
                    >技术服务</div>
                    <div
                      class="clear-item rankItem"
                      @click="currentRank=7"
                      :class="currentRank==7?'active':''"
                    >软件</div>
                    <div
                      class="clear-item rankItem"
                      @click="currentRank=8"
                      :class="currentRank==8?'active':''"
                    >书城</div>
                  </div>
                </div>
              </div>
              <div class="rank">
                <div v-for="(item,index) of ranks" :key="index">
                  <div v-if="index == currentRank" style="margin-top:20px">
                    <div v-for="n in 3" :key="n" style="margin-bottom:35px">
                      <el-row v-if="item[n-1]">
                        <el-col :span="6">
                          <div class="senior_num_img">
                            <router-link target="_blank" :to="'/product/'+item[n-1].id">
                              <img
                                :src="serve +'/'+item[n-1].images"
                                style="width:100%;height:88px"
                              />
                            </router-link>

                            <div :class="'senior_num' + n">
                              <div class="senior_num11">{{n}}</div>
                            </div>
                          </div>
                        </el-col>

                        <el-col :span="15" :offset="2">
                          <div>
                            <div class="t">
                              <router-link
                                target="_blank"
                                :to="'/product/'+item[n-1].id"
                              >{{item[n-1].title}}</router-link>
                            </div>
                            <div
                              class="lv0Text p2"
                              v-if="index!=6"
                            >&yen;{{_.ceil(item[n-1].selling_price)}}</div>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div style="margin-top:20px;">
        <div class="clear">
          <div
            class="clear-item"
            style="width:118px;border:1px solid rgb(245, 245, 245);overflow:hidden;height:108px;cursor: pointer;"
            v-for="(item,index) of brands"
            :key="index"
          >
            <router-link target="_blank" :to="'/viewBrands?id='+item.id">
              <figure class="imghvr-fade" style="background-color:#fff;">
                <div style="height:108px;padding:24.5px 0;width:118px">
                  <img v-lazy="serve +'/'+item.logo_thumb" style="width:118px;height:59px;" />
                </div>
                <figcaption style="background-color:#000;padding:25px 10px;font-size:16px;">
                  <div>
                    <div style="text-align:center;">{{item.name}}</div>
                    <div
                      style="background-color:#e2211c;color:#fff;text-align:center;padding: 5px 0;border-radius:15px;font-size:12px;margin-top:5px"
                    >点击进入</div>
                  </div>
                </figcaption>
              </figure>
            </router-link>
          </div>
        </div>
      </div>

      <div style="margin-top:20px;" v-if="onSale.results && onSale.results.length >= 8">
        <div class="clear" style="margin-bottom:10px" v-if="onSale.discount_ad">
          <div class="clear-item sale-item">
            <router-link target="_blank" :to="onSale.discount_ad.link.split(';')[0]">
              <img v-lazy="serve + '/'+onSale.discount_ad.image.split(';')[0]" style="width:100%" />
            </router-link>
          </div>
          <div class="clear-item sale-item hvr-glow" v-for="n in 4" :key="n">
            <div class="sale">{{onSale.results[n-1].discount_num}}折</div>
            <div align="center">
              <router-link target="_blank" :to="'/product/'+onSale.results[n-1].id">
                <img
                  v-lazy="serve +'/'+onSale.results[n-1].images"
                  style="width:219px;margin:5px 0;height:210px"
                />
              </router-link>
            </div>
            <div
              style="margin:0 10px;line-height:1.3em;height:36px;overflow:hidden;text-align:center"
            >
              <router-link
                target="_blank"
                :to="'/product/'+onSale.results[n-1].id"
              >{{onSale.results[n-1].title}}</router-link>
            </div>
            <div
              class="lv0Text t"
              style="text-align:center;padding-bottom:6px;font-size:18px;margin-top:6px;"
            >&yen;{{onSale.results[n-1].selling_price}}</div>
          </div>
        </div>
        <div class="clear" v-if="onSale.discount_ad">
          <div class="clear-item sale-item">
            <router-link target="_blank" :to="onSale.discount_ad.link.split(';')[1]">
              <img v-lazy="serve +'/'+onSale.discount_ad.image.split(';')[1]" style="width:100%" />
            </router-link>
          </div>
          <div class="clear-item sale-item hvr-glow" v-for="n in 4" :key="n">
            <div class="sale">{{onSale.results[n+3].discount_num}}折</div>
            <div align="center">
              <router-link target="_blank" :to="'/product/'+onSale.results[n+3].id">
                <img
                  v-lazy="serve +'/'+onSale.results[n+3].images"
                  style="width:219px;margin:5px 0;height:210px"
                />
              </router-link>
            </div>
            <div
              style="margin:0 10px;line-height:1.3em;height:36px;overflow:hidden;text-align:center"
            >
              <router-link
                target="_blank"
                :to="'/product/'+onSale.results[n+3].id"
              >{{onSale.results[n+3].title}}</router-link>
            </div>
            <div
              class="lv0Text t"
              style="text-align:center;padding-bottom:6px;font-size:18px;margin-top:6px;"
            >&yen;{{onSale.results[n+3].selling_price}}</div>
          </div>
        </div>
      </div>

      <div style="margin-top:30px" v-if="banner2">
        <router-link target="_blank" :to="banner2.link">
          <img v-lazy="serve +banner2.image" style="width:100%;height:100px" />
        </router-link>
      </div>

      <div style="margin-top:20px">
        <div v-for="(item,index) of data" :key="index">
          <div :id="'f'+index" style="position: relative;top:-60px;"></div>
          <div class="t1">
            <span class="t lv2Text">{{index+1}}F {{item.category}}</span>
            <span>
              <router-link
                target="_blank"
                :to="'/results?topClass='+item.category"
                class="lv3Text more"
              >
                更多
                <i class="iconfont icon-iconfonticonfonti2copycopy" style="font-size:14px"></i>
              </router-link>
            </span>
          </div>

          <div class="clear">
            <router-link target="_blank" :to="item.link">
              <el-image class="ad clear-item" :src="serve  + item.image" fit="cover"></el-image>
            </router-link>

            <div class="clear-item ad-right">
              <el-row :gutter="20">
                <el-col :span="6" v-for="(item2,index2) of item.products" :key="index2">
                  <div class="p-item">
                    <div v-if="item2.discount_num>0" class="discount">{{item2.discount_num}}折</div>
                    <span class="share" v-if="item2.choiceness == 1">
                      <!-- <img src="../../assets/images/share.png" alt=""> -->
                      <span class="share_bio">BioFlin</span>
                      <span class="share_text">精选</span>
                    </span>
                    <router-link target="_blank" :to="'/product/'+item2.id">
                      <div align="center" class="item3">
                        <img v-lazy="serve +item2.images" class="cover2" />
                        <div style="text-align:left" class="l1">
                          <!-- {{_.truncate(item2.title, {
                          'length': 29,
                          })}}-->
                          <span
                            v-if="item2.shop_id == 0"
                            style="background:#E2211C;color:#fff;font-size:12px;padding:0 7px;border-radius:2px;"
                          >自营</span>
                          {{item2.title}}
                        </div>
                        <div class="lv0Text l2" v-if="item2.selling_price == 0">询价</div>
                        <div
                          v-else
                          class="lv0Text l2"
                        >{{item.category!='技术服务/纯化/抗体定制'?'&yen;'+item2.selling_price:"&nbsp;"}}</div>
                      </div>
                    </router-link>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
      <div class="left-menu" v-if="floor>0">
        <div class="lm-item" v-scroll-to="'#f0'" :class="floor==1?'active':''">1F生物耗材</div>
        <div class="lm-item" v-scroll-to="'#f1'" :class="floor==2?'active':''">2F生物实验</div>
        <div class="lm-item" v-scroll-to="'#f2'" :class="floor==3?'active':''">3F生物试剂</div>
        <div class="lm-item" v-scroll-to="'#f3'" :class="floor==4?'active':''">4F生物抗体</div>
        <div class="lm-item" v-scroll-to="'#f4'" :class="floor==5?'active':''">5F实验动物</div>
        <div class="lm-item" v-scroll-to="'#f5'" :class="floor==6?'active':''">6F仪器设备</div>
        <div class="lm-item" v-scroll-to="'#f6'" :class="floor==7?'active':''">7F技术服务</div>
        <div class="lm-item" v-scroll-to="'#f7'" :class="floor==8?'active':''">8F实验装置</div>
        <div class="lm-item" v-scroll-to="'#f8'" :class="floor==9?'active':''">9F生物软件</div>
        <div class="lm-item" v-scroll-to="'#f9'" :class="floor==10?'active':''">10F生物书城</div>
        <div class="lm-item" v-scroll-to="'#f10'" :class="floor==11?'active':''">11F生物制药</div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueScrollTo from "vue-scrollto";

Vue.use(VueScrollTo, options);
let options = {
  container: "body",
  duration: 1,
  offset: 0,
  force: true
};

export default {
  data() {
    return {
      serve: this.$store.state.serve,

      is_headimg: false,
      second_bg: "",
      flag: true,
      second_title: "",
      //
      ads: null,
      floor: 0,
      hoverId: null,
      show: false,
      cate: {},
      words: null,
      onSale: {},
      required: {},
      brands: null,
      good: null,
      rankDistance: 0,
      currentRank: 0,
      ranks: {},
      moveAllow: true,
      showRushC: false,
      newsList: {},
      images2: {},
      qr1: "",
      keywords2: "",
      fixedMenu: false,
      rightId: 0,
      data: {},
      cate: [],
      banner: [],
      topProducts: [],
      rushProduct: [],
      currentRound: 0,
      m: 0,
      exchange: [],
      news: [],
      menuContent: "",
      adContent: "",
      menuV: false,
      hours: "",
      minutes: 0,
      seconds: 0,
      distance: 0,
      second: 0,
      cateRight: "",
      rightAd: [],
      h2: 0,
      hoverId: 0,
      rushDistance: 0,
      interval: null,
      setInterval: null,
      rankMoveAllow: true,
      dis: 0,
      dis2: 0,
      cartIsEmpty: true,
      loadingCart: true,
      carts: [],
      count: null,
      total: null,
      banner2: null,
      banner_link: [],
      isLogin: null,
      isLogin_monile: "",
      isLogin_img: ""
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  activated() {
    const P_path = this.$route.query.user_from;
    if (P_path) {
      this.$cookies.set("user_from", P_path);
    }
    this.$store.commit("set_top_nav", "1");
    this.axios
      .get(this.serve + "/isLogin", {
        params: {
          mobile: this.$cookies.get("user"),
          token: this.$cookies.get("token")
        }
      })
      .then(res => {
        if (res.data.data == "1") {
          this.isLogin = true;
        } else {
          this.isLogin = false;
        }
      });
    this.axios
      .get(this.serve + "/head_and_bindmobile", {
        params: {
          mobile: this.$cookies.get("user"),
          token: this.$cookies.get("token")
        }
      })
      .then(res => {
        if (res.data.status == "success") {
          this.isLogin_monile = res.data.data.bind_mobile;
          this.isLogin_img = res.data.data.headImg;
        }
      });
  },
  created() {
    this.axios
      .get(this.serve + "/isLogin", {
        params: {
          mobile: this.$cookies.get("user"),
          token: this.$cookies.get("token")
        }
      })
      .then(res => {
        if (res.data.data == "1") {
          this.isLogin = true;
        } else {
          this.isLogin = false;
        }
      });
    this.axios
      .get(this.serve + "/head_and_bindmobile", {
        params: {
          mobile: this.$cookies.get("user"),
          token: this.$cookies.get("token")
        }
      })
      .then(res => {
        if (res.data.status == "success") {
          this.isLogin_monile = res.data.data.bind_mobile;
          this.isLogin_img = res.data.data.headImg;
        }
      });
    var that = this;
    this.initData();
    var that = this;
    var h = that.dayjs().hour();
    this.h2 = h % 2 == 0 ? h + 2 : h + 1;
    // setInterval(function() {
    //   var h = that.dayjs().hour();
    //   var h2 = h % 2 == 0 ? h + 2 : h + 1;
    //   var date1 = that.dayjs();
    //   var date2 = that.dayjs(
    //     that.dayjs().format("YYYY-MM-DD" + " " + h2 + ":00:00")
    //   );
    //   that.distance = date2.diff(date1);
    //   that.hours = Math.floor(
    //     (that.distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    //   );
    //   that.minutes = Math.floor(
    //     (that.distance % (1000 * 60 * 60)) / (1000 * 60)
    //   );
    //   that.seconds = Math.floor((that.distance % (1000 * 60)) / 1000);
    // }, 1000);
  },
  watch: {
    // isLogin: function(o, l) {
    //   if (o) {
    //     this.isLogin = 1;
    //   }
    // },
    // $route(v, o) {
    //   if (o.path == "/login") {
    //     // window.location.reload();
    //   }
    // },
    currentRank: function(i) {
      if (this.rankMoveAllow) {
        this.rankMoveAllow = false;
        var that = this;
        var targetDistance = (i - 2) * 86;
        if (targetDistance < 0) {
          targetDistance = 0;
        }
        this.setInterval = setInterval(() => {
          if (this.rankDistance < targetDistance) {
            this.rankDistance += 2;
          } else if (this.rankDistance > targetDistance) {
            this.rankDistance -= 2;
          } else {
            clearInterval(that.setInterval);
            that.rankMoveAllow = true;
          }
          this.$refs.rankItem.style.right = this.rankDistance + "px";
        }, 1);
      }
    }
  },
  methods: {
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 96) {
        this.fixedMenu = true;
      } else {
        this.fixedMenu = false;
      }
      var dis = 650;
      for (var n = 1; n < 12; n++) {
        if (scrollTop > dis * (n - 1) + 2704 && scrollTop <= dis * n + 2704) {
          this.floor = n;
        } else if (scrollTop <= 2704) {
          this.floor = 0;
        }
      }
    },
    loadCart() {
      var that = this;
      this.loadingCart = true;
      this.carts = [];
      this.axios
        .get(this.serve + "/member/get_car_three", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          this.loadingCart = false;
          if (res.data.results) {
            that.cartIsEmpty = false;
            that.carts = res.data.results;
            that.count = res.data.count;
            that.total = res.data.money;
            that.$store.commit("set", res.data.count);
            for (var item of that.carts) {
              var img = item.images.split(";");
              item.cover = img[0];
            }
          } else {
            that.cartIsEmpty = true;
            that.carts = [];
            that.count = 0;
            that.total = 0;
          }
        });
    },
    handleSelect() {},
    search() {
      if (this.keywords != "") {
        this.$router.push({
          path: "/results",
          query: { keywords: this.keywords2 }
        });
      }
    },
    autoComplete(queryString, cb) {
      this.axios
        .get(this.serve + "/autocomplete", {
          params: {
            keywords: queryString
          }
        })
        .then(res => {
          for (var item of res.data) {
            item.value = item.title;
          }
          cb(res.data);
        });
    },
    leftBtn() {
      if (this.rushDistance > 0 && this.moveAllow) {
        var targetDistance = this.rushDistance - 200;
        this.moveAllow = false;
        var that = this;
        this.interval = setInterval(() => {
          if (this.rushDistance > targetDistance) {
            this.rushDistance -= 10;
            for (var i = 0; i < this.$refs.rushItem.length; i++) {
              this.$refs.rushItem[i].style.left = -this.rushDistance + "px";
            }
          } else {
            that.moveAllow = true;
            clearInterval(that.interval);
          }
        }, 10);
      }
    },
    rightBtn() {
      if (this.rushDistance < 600 && this.moveAllow) {
        var targetDistance = this.rushDistance + 200;
        var that = this;
        this.moveAllow = false;
        this.interval = setInterval(() => {
          if (this.rushDistance < targetDistance) {
            this.rushDistance += 10;
            for (var i = 0; i < this.$refs.rushItem.length; i++) {
              this.$refs.rushItem[i].style.left = -this.rushDistance + "px";
            }
          } else {
            clearInterval(that.interval);
            that.moveAllow = true;
          }
        }, 10);
      }
    },
    showMenu(i) {
      if (this.cate[i].data) {
        this.menuContent = this.cate[i].data;
        this.hoverId = i;
      }
    },
    initData() {
      this.axios.get(this.serve + "/category_ad_image").then(res => {
        for (var item of res.data.data) {
          this.rightAd.push(item);
        }
      });
      this.axios.get(this.serve + "/get_category").then(res => {
        this.cate = res.data;
        this.$store.commit("setMenu", res.data);
      });
      this.axios.get(this.serve + "/request_rush_list").then(res => {
        this.required = res.data;
      });
      this.axios.get(this.serve + "/index_notice").then(res => {
        this.ads = res.data;
      });
      this.axios.get(this.serve + "/discount_goods").then(res => {
        this.onSale = res.data;
      });
      this.axios.get(this.serve + "/banner_right_img").then(res => {
        this.images2 = res.data.data;
      });
      this.axios.get(this.serve + "/find_good_goods").then(res => {
        this.good = res.data.data;
      });
      this.axios.get(this.serve + "/brand_30").then(res => {
        this.brands = res.data.data;
      });
      this.axios.get(this.serve + "/rank_list").then(res => {
        this.ranks = res.data.data;
      });
      this.axios.get(this.serve + "/hot_news").then(res => {
        this.newsList = res.data.data.results;
      });
      this.axios.get(this.serve + "/get_index_banner").then(res => {
        var data = res.data.image;
        this.banner = data.split(";");
        this.banner_link = res.data.link.split(";");
      });
      this.axios.get(this.serve + "/guanwei_img").then(res => {
        this.qr1 = res.data.data;
      });
      this.axios.get(this.serve + "/get_tower").then(res => {
        this.data = res.data;
      });
      this.axios.get(this.serve + "/has_inventory").then(res => {
        this.topProducts = res.data;
      });
      this.axios.get(this.serve + "/index_rush_product").then(res => {
        if (res.data.title == "综合专场") {
          this.second_bg = "second_bg1";
        } else if (res.data.title == "耗材专场") {
          this.second_bg = "second_bg2";
        } else if (res.data.title == "试剂专场") {
          this.second_bg = "second_bg3";
        }
        this.second = res.data.second;
        this.second_title = res.data.title;
        this.rushProduct = res.data.rush;
        if (this.flag) {
          var that = this;
          that.flag = false;
          var t1 = setInterval(function(e) {
            if (that.second <= 0) {
              clearInterval(t1);
              that.istab = true;
              that.istab1 = false;
            } else {
              that.istab = false;
              that.istab1 = true;
            }
            that.second--;
            var surplus = that.second;
            that.hours = Math.floor(surplus / 3600);
            that.minutes = Math.floor((surplus % 3600) / 60);
            that.seconds = surplus % 60;
          }, 1000);
          that.flag = true;
        }
        for (var item of this.rushProduct) {
          item.number = _.toInteger(item.number);
          item.sell_number = _.toInteger(item.sell_number);
          var p = (item.number / (item.number + item.sell_number)) * 100;
          item.percent = _.floor(p);
        }
      });

      this.axios.get(this.serve + "/exchange_bioflinnews").then(res => {
        this.exchange = res.data.exchange;
        this.news = res.data.bioflinnews;
      });

      this.axios.get(this.serve + "/index_second_banner").then(res => {
        this.banner2 = res.data.data;
      });
    }
  }
};
</script>

<style lang="scss">
#index2 {
  .new_year {
    .new_year1 {
      width: 150px;
      height: 200px;
      position: fixed;
      top: 24px;
      left: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .new_year2 {
      width: 150px;
      height: 200px;
      position: fixed;
      top: 34px;
      right: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .new_year3 {
      width: 150px;
      height: 60px;
      position: fixed;
      bottom: 16px;
      left: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .rush_price_g {
    width: 180px;
    margin: 10px auto 10px auto;
    height: 30px;
    display: flex;
    position: relative;
    border: 1px solid rgba(226, 33, 28, 1);
    text-align: center;
    line-height: 30px;
    .rush_price_g1 {
      width: 50%;
      height: 100%;
      background: #e2211c;
      font-size: 16px;
      font-family: " Microsoft YaHei";
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
    }
    .rush_price_g1_bg {
      position: absolute;
      left: 50%;
      margin-left: -15px;
      background-color: #fff;
      border-top: 30px solid #e2211c;
      border-right: 30px solid rgba(226, 33, 28, 0);
    }
    .rush_price_g2 {
      background: #fff;
      width: 50%;
      height: 100%;
      font-size: 14px;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      text-decoration: line-through;
      color: rgba(102, 102, 102, 1);
    }
  }
  .sechill_hover {
    width: 160px;
    height: 160px;
    overflow: hidden;
    margin: 0px auto;
  }
  .sechill_hover_img {
    width: 100%;
    height: 100%;
    display: block;
    transform: scale(1.3);
    transition: all 0.6s;
    -webkit-transform: scale(1);
    -webkit-transform: all 1s ease 0s;
  }
  .sechill_hover_img:hover {
    transition: all 0.6s;
    transform: scale(1.3);
    -webkit-transform: scale(1.3);
    -webkit-transform: all 1s ease 0s;
  }
  .car_shopping {
    width: 100%;
    .cartDialogue1 {
      height: 400px;
      overflow: scroll;
      overflow-x: auto;
    }
    .cartDialogue {
      // height: 400px;
      // overflow: scroll;
      // overflow-x: auto;
      .cartDialogue_top {
        font-size: 12px;
        font-family: "Microsoft YaHei";
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin-bottom: 12px;
      }
      .car_list {
        height: 70px;
        background: #fff;
        width: 100%;
        border-bottom: 1px dashed rgba(221, 221, 221, 1);
        display: flex;
        justify-content: space-between;
        align-items: center;
        .img {
          width: 50px;
          height: 50px;
          background: rgba(204, 204, 204, 1);
          border: 1px solid rgba(204, 204, 204, 1);
        }
        .title {
          font-family: "Microsoft YaHei";
          font-weight: 400;
          .title_div1 {
            font-size: 14px;
            color: rgba(226, 33, 28, 1);
          }
          .title_div5 {
            width: 190px;
          }
          .title_div2 {
            font-size: 12px;
            color: rgba(226, 33, 28, 1);
          }
          .title_div3 {
            font-size: 12px;
            margin-left: 30px;
          }
          .title_div4 {
            cursor: pointer;
          }
          .title_div4:hover {
            color: #e2211c;
          }
        }
        .money {
          width: 70px;
        }
      }
    }
    .go_shopping {
      display: flex;
      justify-content: space-between;
      width: 100%;
      align-items: center;
      height: 48px;
      background: rgba(245, 245, 245, 1);
    }
  }
  .bioflin_advisory:hover {
    color: #e2211c;
  }
  .more:hover {
    color: #e2211c;
  }
  .cate-menu2 {
    position: absolute;
    top: -330px;
    a:hover {
      color: #e2211c;
    }
    background-color: #fff;
    position: relative;
    left: 200px;
    width: 960px;
    padding: 10px 20px;
    min-height: 310px;
  }
  .cate-menu1 {
    .item {
      display: block;
      position: relative;
      line-height: 30px;
      height: 30px;
      background-color: #fff;
      padding-left: 20px;
      width: 180px;
      cursor: pointer;
    }
    .item:hover {
      background-color: #ddd;
    }
  }
  .onHover {
    background-color: #e2211c;
    color: #fff;
  }
  .p-item {
    margin-bottom: 20px;
    border: 1px solid rgb(245, 245, 245);
    position: relative;
    .share {
      position: absolute;
      left: 0;
      top: 0;
      font-size: 12px;
      height: 20px;
      line-height: 20px;
      .share_bio {
        background: rgba(226, 33, 28, 1);
        color: rgba(255, 255, 255, 1);
        font-family: "DengXian-Bold";
        font-weight: bold;
        height: 12px;
        padding: 2px;
      }
      .share_text {
        background: rgba(40, 40, 40, 1);
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        height: 12px;
        padding: 2px;
        // padding-left: 4px;
      }
    }
  }
  .p-item:hover {
    border: 1px solid #e2211c;
  }
  .sale-item:nth-child(1),
  .sale-item:nth-child(2),
  .sale-item:nth-child(3),
  .sale-item:nth-child(4) {
    width: 230px;
    background-color: #fff;
    margin-right: 12px;
  }
  .sale-item:nth-child(5) {
    width: 230px;
    background-color: #fff;
  }
  .sale-item .sale {
    background-color: #e2211c;
    display: block;
    padding: 2px 0;
    width: 62px;
    color: #fff;
    text-align: center;
    font-size: 12px;
    margin: 0 auto;
  }
  .sale-item {
    a:hover {
      color: #e2211c;
    }
  }
  .rank {
    .senior_num_img {
      position: relative;
      .senior_num1 {
        color: #fff;
        position: absolute;
        left: -10px;
        top: -10px;
        width: 0;
        height: 0;
        border-top: 15px solid #f53731;
        border-right: 10px solid #f53731;
        border-bottom: 10px solid rgba(255, 255, 255, 0);
        border-left: 10px solid #f53731;
      }
      .senior_num2 {
        color: #fff;
        position: absolute;
        left: -10px;
        top: -10px;
        width: 0;
        height: 0;
        border-top: 15px solid #ee6f2c;
        border-right: 10px solid #ee6f2c;
        border-bottom: 10px solid rgba(255, 255, 255, 0);
        border-left: 10px solid #ee6f2c;
      }
      .senior_num3 {
        color: #fff;
        position: absolute;
        left: -10px;
        top: -10px;
        width: 0;
        height: 0;
        border-top: 15px solid #f5b941;
        border-right: 10px solid #f5b941;
        border-bottom: 10px solid rgba(255, 255, 255, 0);
        border-left: 10px solid #f5b941;
      }
      .senior_num11 {
        position: absolute;
        left: -4px;
        top: -15px;
      }
    }
    .t a:hover {
      color: #e2211c;
    }
    .p2 {
      margin-top: 10px;
    }
  }
  .bt4 .el-link {
    background-color: #ffdada;
    width: 70px;
    padding: 5px 0;
    margin: 0 5px;
    border-radius: 20px;
    text-align: center;
  }
  .bt4 {
    border-bottom: 1px solid #ddd;
    padding-bottom: 20px;
  }
  .bt3 .el-button {
    border-color: #e2211c;
    color: #e2211c;
    margin-bottom: 20px;
  }
  .bt3 a {
    display: inline-block;
    margin: 0 3px;
  }
  .n1 {
    color: #e2211c;
  }
  .n2 {
    color: #ed713d;
  }
  .n3 {
    color: #feb185;
  }
  .rankRow {
    margin-bottom: 20px;
  }
  .rankTitle {
    font-size: 12px;
    height: 3em;
    line-height: 1.5em;
    overflow: hidden;
    margin-bottom: 10px;
  }
  .rankItemDiv {
    position: relative;
  }
  .rankItem {
    margin: 0 5px;
    padding: 3px 0;
    width: 77px;
    text-align: center;
    cursor: pointer;
  }
  .rankItem.active,
  .rankItem:hover {
    background-color: #e2211c;
    color: #fff;
    border-radius: 11px;
  }
  .box2 {
    .fas {
      margin-left: 5px;
    }
    .lookGood {
      // height: 16px;
      // overflow: hidden;
      text-align: center;
      cursor: pointer;
    }
    .lookGood:hover .lookGood_a {
      color: #e2211c;
    }
    background-color: #fff;
    width: 348px;
    height: 460px;
    padding: 20px 19px;
    .t2 {
      font-size: 20px;
      font-weight: bold;
      .new_pai {
        color: #db5757;
        cursor: pointer;
      }
      .new_pai:hover {
        color: #e2211c;
      }
      .new_pai_span:hover {
        color: #e2211c;
      }
      a {
        font-size: 14px;
        font-weight: normal;
        margin-top: 5px;
      }
    }
    .t3 {
      font-size: 20px;
      font-weight: bold;
      .new_biqiang {
        color: #69a88f;
      }
      .new_biqiang:hover {
        color: #e2211c;
      }
      .new_biqiang_span:hover {
        color: #e2211c;
      }
      .new_biqiang1 {
        color: #ff9902;
      }
      .new_biqiang1:hover {
        color: #e2211c;
      }
      .new_biqiang_span:hover {
        color: #e2211c;
      }
    }
  }
  .showRushC {
    position: absolute;
    top: 96px;
    background-color: rgba($color: #000000, $alpha: 0.2);
    color: #fff;
    padding: 10px 5px;
    cursor: pointer;
    opacity: 0.6;
  }
  .showRushC:hover {
    opacity: 1;
  }
  .showRushC.right {
    right: 0;
  }
  .rushItem {
    a:hover {
      color: #e2211c;
    }
    width: 199px;
    height: 314px;
    position: relative;
    border-right: 1px solid #ddd;
    background-color: #fff;
  }
  .newsItem {
    position: relative;
    width: 170px;
    margin-bottom: 15px;
    line-height: 1.5em;
  }
  .newsItem,
  .newsItem2 {
    a:hover {
      text-decoration: underline;
      color: #e2211c;
    }
  }
  .box1 {
    background-color: #fff;
    display: block;
    width: 100%;
    height: 227px;
  }
  .box3 {
    background-color: #fff;
    display: block;
    width: 167px;
    height: 300px;
    padding: 10px;
  }
  .car1 {
    .el-carousel__arrow {
      border-radius: 0;
      height: 50px;
      width: 30px;
      font-size: 20px;
    }
    .el-carousel__arrow--right {
      right: 0;
    }
    .el-carousel__arrow--left {
      left: 0;
    }
    .el-carousel {
      overflow: hidden;
      height: 330px;
    }
    .el-carousel__item {
      height: 330px;
    }
    .el-carousel__button {
      height: 14px;
      width: 14px;
      border-radius: 14px;
      border: 1px solid #e2211c;
      background-color: transparent;
      margin: 0 8px;
    }
  }
  .car2 {
    .el-carousel__arrow {
      border-radius: 0;
      height: 50px;
      width: 30px;
      font-size: 20px;
    }
    .el-carousel__arrow--right {
      right: 0;
    }
    .el-carousel__arrow--left {
      left: 0;
    }
    .el-carousel {
      overflow: hidden;
    }
    .el-carousel__button {
      height: 14px;
      width: 14px;
      border-radius: 14px;
      border: 1px solid #e2211c;
      background-color: transparent;
      margin: 0 8px;
    }
  }
  .is-active .el-carousel__button {
    background-color: #e2211c;
  }
  .qr1 {
    position: relative;
    right: 170px;
    top: -90px;
    animation-duration: 0.5s;
  }
  .el-input-group__append {
    background-color: #e2211c;
    color: #fff;
    border: 1px solid #e2211c;
  }
  .fMenu {
    animation-duration: 0.5;
    background-color: #fff;
    position: fixed;
    top: 0;
    display: block;
    width: 100%;
    z-index: 99;
  }
  .hide {
    display: none;
  }
  .left-menu {
    position: fixed;
    margin-left: -100px;
    top: 200px;
    z-index: 100;
    .lm-item {
      background-color: #fff;
      width: 88px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
      margin-bottom: 1px;
    }
    .lm-item:hover,
    .lm-item.active {
      background-color: #e2211c;
      color: #fff;
    }
  }
  .el-divider.el-divider--vertical {
    position: relative;
    top: -1px;
  }
  .discount {
    background-color: #e2211c;
    color: #fff;
    font-size: 12px;
    padding: 2px 10px;
    border-radius: 10px;
    display: inline;
    float: right;
    margin-bottom: -35px;
    margin-right: 10px;
    margin-top: 5px;
    position: relative;
    z-index: 10;
  }
  .hidden {
    display: none;
  }
  .menu2 {
    padding: 10px;
  }
  .menu {
    background-color: #fff;
    .menu-item {
      height: 462px;
      width: 1000px;
    }
    .sp:hover {
      text-decoration: underline;
      color: #e2211c;
      a {
        color: #e2211c;
      }
    }
    font-size: 13px;
    height: 462px;
    width: 1000px;
    background-color: #fff;
    position: relative;
    float: left;
    top: -462px;
    z-index: 199;
    left: 200px;
    margin-bottom: -462px;
    .el-link {
      font-size: 13px;
    }
  }
  .exchange {
    border-radius: 10px;
    padding: 10px 0;
  }
  .x1 {
    background-color: #1d1818;
    font-size: 20px;
    font-family: "Microsoft YaHei";
    font-weight: bold;
    color: #fff;
    text-align: center;
    display: inline-block;
    width: 34px;
    height: 34px;
    line-height: 34px;
    // padding: 10px 8px;
    margin: 0px 5px;
  }
  .s1 {
    width: 80px;
    display: inline-block;
  }
  .cover4 {
    width: 387px;
    height: 217px;
    background-position: center;
    background-size: 100% auto;
  }
  .news-item {
    background-color: #fff;
  }
  .item3 {
    background-color: #fff;
  }
  .rush {
    color: #e2211c;
    cursor: pointer;
  }
  .ad-right {
    width: 960px;
  }
  .ad {
    width: 225px;
    height: 646px;
    margin-right: 15px;
    background-size: 100% auto;
    background-position: center;
  }
  .rush-item {
    width: 225px;
    margin-right: 15px;
    background-color: #fff;
  }
  .rush-item2 {
    width: 200px;
    color: #fff;
    // background-color: #e2211c;
    height: 270px;
  }
  .second_bg1 {
    background-color: #c72e08;
  }
  .second_bg2 {
    background-color: #e2211c;
  }
  .second_bg3 {
    background-color: #ef2767;
  }
  .p {
    background-color: #fff;
    padding: 10px;
  }
  .p img {
    width: 100%;
  }
  .l1 {
    padding: 10px 20px 5px 20px;
    text-align: left;
    line-height: 1.5em;
    height: 42px;
    overflow: hidden;
  }
  .l1:hover {
    color: #e2211c;
  }
  .l2 {
    padding: 5px 0 10px 0;
  }
  .cover2 {
    width: 203px;
    height: 203px;
    padding: 10px;
  }
  .cover {
    display: block;
    width: 285px;
    height: 285px;
  }
  .item {
    background-color: #fff;
  }
  padding-bottom: 50px;
  .t1 {
    margin: 0px 0 20px 0;
    .t {
      font-size: 22px;
      margin-right: 10px;
    }
  }
  .cate {
    color: #fff;
    width: 200px;
    display: block;
  }
  .cate-item {
    a {
      color: #333;
    }
    display: block;
    width: 190px;
    padding-left: 10px;
    line-height: 42px;
    height: 42px;
    background-color: #fff;
  }
  .cate-item:hover {
    background-color: #ddd;
  }
}
</style>